export const getEventUserInfo = (
  userId: string
): { authStatus: 'registered' | 'guest' } => {
  return {
    authStatus: userId === 'current' ? 'registered' : 'guest',
  };
};
